import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';



var url =  window.location.hostname;
var port = window.location.port;
const Heading = [['ID','Party Code',  'Party Name'  ,'Beat Name', 'Retailer Code',  'Area Code',  'Channel' ,'PL Group',  'Sales Day',  'Salesman', 'Salesman Code',"Retailer hul code" ,
    "Retailer Type"             ,
    "Hul Area" ,
    "Hub Sub Area" ,
    "Hul Street" ,
    "Rs Code"   ,
    "Credit Days" ,
    "Cross dock distributor id" ,
    "Payment terms updated by"]]




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.fetchBinData = this.fetchBinData.bind(this);

    this.state = {
	  loading_overlay: false,	
      file: {},
      data: [],
      showInvalidItem: false,
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      loading: false,
      isLoading:true,
      showFetchBinData: true,
      show_process_data: true,
      filtered_orderData :[],
      tableRows: [],
    };
  }


 

  componentDidMount(){
  this.fetchBinData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }

 

  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
		loading_overlay:true
      })


     const payload={  master_type: "outlet_master",
     location: this.state.selectedLocation,}
API.post('/customer/view/v1/', { param: payload })
          

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         // if (err) throw err;

         this.setState({ posts: data.data ,filtered_orderData :data.data})

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      
      var value = this.state.posts.filter(
        (val) =>
        
          val.retailer_code.toLowerCase().includes(evt.toLowerCase()) ||
          val.party_code.toLowerCase().includes(evt.toLowerCase()) ||
          val.beat_name.toLowerCase().includes(evt.toLowerCase()) ||
          val.area_code.toLowerCase().includes(evt.toLowerCase()) ||
          val.pl_group.toLowerCase().includes(evt.toLowerCase()) ||
          val.party_name.toLowerCase().includes(evt.toLowerCase()) ||
          val.salesman.toLowerCase().includes(evt.toLowerCase()) ||
          val.salesman_code.toLowerCase().includes(evt.toLowerCase()) 
          
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };


 


  assemblePosts= () => {

    let posts =this.state.posts.map((post) => {

      return (

        {

          party_code: post.party_code,

          party_name: post.party_name,
          beat_name: post.beat_name,
          retailer_code: post.retailer_code,
          area_code: post.area_code,
          channel: post.channel,
          pl_group: post.pl_group,
          sales_day: post.sales_day,
          salesman: post.salesman,
          salesman_code: post.salesman_code






          

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }




 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem)
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    const data = {

      columns: [

        {

          label:'Party Code',

          field:'party_code',
          sort: 'asc',

        },

        {

          label:'Party Name',

          field:'party_name',
          sort: 'asc',

        },

        {

          label:'Beat Name',

          field:'beat_name',
          sort: 'asc',

        },

        {

          label:'Retailer Code',

          field:'retailer_code',
          sort: 'asc',

        },

        {

          label:'Area Code',
          field:'area_code',
          sort: 'asc',

        },


        {

          label:'Channel',

          field:'channel',
          sort: 'asc',

        },

        {

          label:'PL Group',

          field:'pl_group',
          sort: 'asc',

        },

        {

          label:'Sales Day',

          field:'sales_day',
          sort: 'asc',

        },
         {

          label:'Salesman',

          field:'salesman',
          sort: 'asc',

        },
        {

          label:'Salesman Code',

          field:'salesman_code',
          sort: 'asc',

        }

        

      ],

      rows:this.state.tableRows,

    }


   

    return (
      <Col xl={12}>
	       {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          

         




          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">OutletMaster Master</h4>
              
			  <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.filtered_orderData, "OutletMaster", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            <MDBDataTable
            striped
            onSearch={this.filterData}
            sortable={false}
            bordered
            hover
            data={data}
            onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'outlet_master_view', 'datatable_pagination_change' )}
          />
          </CardBody>

          )}


        </Card>
  
      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));